module.exports = __webpack_public_path__ + "img/39.bcba6d04.jpg";